<template>
    <v-app>
        <v-app-bar
        app
        color="secondary"
        dark
       
        >
            <div class="d-flex align-center primary--text">
                <v-img                
                class="shrink mr-2"
                contain
                src="../../assets/logo.png"
                transition="scale-transition"
                width="60"
                />
                {{ schoolName}}
                
            </div>

            <v-spacer></v-spacer>

            <v-btn
                color="primary"
                size="36"                
                fab
                dark
                small
                elevation="0"                
            >
            {{ userInitials }}               
            </v-btn>

            <Logout/>
        </v-app-bar>

        <v-main class="grey lighten-5" >            
            <v-container 
                fluid
                class="grey lighten-5"                               
            >                                   
                <div class="primary--text"> 
                    <span class="text-body-1 mr-3">Welcome</span> 
                    <span class="font-weight-light font-italic text-h5">{{ userRecord.name }}</span>
                </div>
                <slot></slot>
                
            </v-container>                           
        </v-main>
        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>
    </v-app> 
    
</template>

<script>
import Logout from '../auth/Logout';
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  components: {    
    Logout, 
  },

  data: () => ({
     documentTop: true,     
     floatingButton: false,     
  }),

  methods: {
      quickScroll(){
          this.documentTop = !this.documentTop;
          if(this.documentTop){
              window.scrollTo(0, document.body.scrollHeight);
          }
      },
      changePassword(){
          this.$router.push('/registration/change-password');
      }

  },

  computed: {              
      ...mapGetters({         
          schoolName: 'auth/getSchoolName',          
          userInitials: 'auth/getUserInitials',
          userRecord: 'auth/getUserRecord',
          overlay: 'auth/getOverlay',
      })
      
  }
};
</script>


